import React from 'react';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { GridTableContext } from '../contexts';

export function RefreshButton({ onClick }: { onClick?: () => void }): JSX.Element {
  const {
    fetchData,
    instance: { gotoPage, setPageSize, setGlobalFilter },
    paginationSize
  } = React.useContext(GridTableContext);
  const label = 'Refresh';
  return (
    <Tooltip title={label}>
      <IconButton
        onClick={(): void => {
          if (onClick) {
            onClick();
          }
          gotoPage(0);
          setPageSize(paginationSize[0]);
          setGlobalFilter(undefined);
          fetchData();
        }}
        aria-label={label}
      >
        <RefreshIcon />
      </IconButton>
    </Tooltip>
  );
}
